export enum AccountRoleEnum {
    owner = 'OWNER',
    admin = 'ADMIN',
    billing = 'BILLING',
}
